"use client";

import { getMap } from "@utils/googlePlaces";
import { useThemeContext } from "@utils/hooks";
import { useMotionValueEvent, useScroll } from "framer-motion";
import { useEffect, useRef } from "react";

interface Props {
  lat: string;
  long: string;
}

const RADIUS_CUTOFF_START = 344;
const RADIUS_CUTOFF_END = 387;

export default function VenueMap({ lat, long }: Props) {
  const theme = useThemeContext();
  const mapRef = useRef<HTMLDivElement>(null);
  const { scrollY } = useScroll();

  useEffect(() => {
    const distance_from_bottom =
      document.body.scrollHeight - window.innerHeight - window.scrollY;
    const radius =
      distance_from_bottom < RADIUS_CUTOFF_START
        ? 0
        : distance_from_bottom > RADIUS_CUTOFF_END
        ? 1
        : (distance_from_bottom - RADIUS_CUTOFF_START) /
          (RADIUS_CUTOFF_END - RADIUS_CUTOFF_START);

    document
      .getElementById("venue_content")
      ?.style.setProperty("border-bottom-left-radius", `${radius}rem`);
    document
      .getElementById("venue_content")
      ?.style.setProperty("border-bottom-right-radius", `${radius}rem`);
  }, []);

  useMotionValueEvent(scrollY, "change", () => {
    const distance_from_bottom =
      document.body.scrollHeight - window.innerHeight - window.scrollY;
    const radius =
      distance_from_bottom < RADIUS_CUTOFF_START
        ? 0
        : distance_from_bottom > RADIUS_CUTOFF_END
        ? 1
        : (distance_from_bottom - RADIUS_CUTOFF_START) /
          (RADIUS_CUTOFF_END - RADIUS_CUTOFF_START);

    document
      .getElementById("venue_content")
      ?.style.setProperty("border-bottom-left-radius", `${radius}rem`);
    document
      .getElementById("venue_content")
      ?.style.setProperty("border-bottom-right-radius", `${radius}rem`);
  });

  useEffect(() => {
    if (window !== undefined && mapRef.current) {
      getMap(
        mapRef.current,
        parseFloat(lat),
        parseFloat(long),
        !!(theme && theme.appearance === "dark")
      );
    }
  }, [mapRef, lat, long, theme]);

  return <div ref={mapRef} className="w-full h-full" />;
}
